import { styled } from "goober";

export const chatContentSpacing = `
  --chat-content-gutter: 32px;
  @container (max-width: 768px) {
    --chat-content-gutter: 12px;
  }
`;

export const ChatContent = styled("div")`
  ${chatContentSpacing}
  --chat-content-max-width: 820px;
  --chat-feed-inset: 48px;
  @container (max-width: 768px) {
    --chat-feed-inset: 36px;
  }
  @container (max-width: 480px) {
    --chat-feed-inset: 24px;
  }
  display: flex;
  flex-direction: column;
  max-width: var(--chat-content-max-width);
  width: 100%;
  margin: 0 auto;
  padding: 0 var(--chat-content-gutter);
  box-sizing: border-box;
  transition: padding var(--motion-base) var(--ease-out);
`;
